export function getMetaTagValue(name) {
  return document.head.querySelector(`meta[name="${name}"]`).getAttribute('content');
}
